export default {"src":"/_next/static/media/mana14.bf4e5d39.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};